/* Greenworks Style Theme — minimal interactions */
(function () {
  'use strict';

  // Mobile nav toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-nav-list]');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  // Variant selector -> update hidden id + price on product page
  function initProductForm(form) {
    var variantsData = form.querySelector('[data-variants-json]');
    if (!variantsData) return;
    var variants = JSON.parse(variantsData.textContent);
    var selects = form.querySelectorAll('.variant-selects select');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn = form.querySelector('[data-add-btn]');

    function currentOptions() {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    }
    function update() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl && match.price != null) {
        priceEl.textContent = formatMoney(match.price);
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.dataset.addLabel : addBtn.dataset.soldLabel;
      }
    }
    Array.prototype.forEach.call(selects, function (s) {
      s.addEventListener('change', update);
    });
    update();
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  document.querySelectorAll('[data-product-form]').forEach(initProductForm);

  // Product gallery: swipe on mobile (native scroll-snap), click thumbnails on desktop
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-slides]');
    if (!track) return;
    var slides = track.querySelectorAll('.product__slide');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    var dots = gallery.querySelectorAll('.product__dot');

    function setActive(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }

    // Click a thumbnail -> scroll that slide into view
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = parseInt(thumb.getAttribute('data-index'), 10) || 0;
        if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });

    // Keep active dot/thumb in sync while swiping
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(i);
      });
    }, { passive: true });
  });

  // Newsletter demo (no backend): show success without leaving page if it's the placeholder form
  document.querySelectorAll('[data-newsletter-demo]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = form.querySelector('[data-newsletter-msg]');
      if (msg) msg.hidden = false;
      form.reset();
    });
  });
})();